import { Typography } from '@material-ui/core';
import React from 'react';
import { formatMoney } from '../../../include/utils';
const priceRowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '18px',
    alignItems: 'baseline',
};
const priceValueStyle = {
    whiteSpace: 'nowrap',
    fontWeight: 500,
};
const popupViewportGap = 8;
const popupFlipGap = 10;
const isClippingElement = (element) => {
    const style = window.getComputedStyle(element);
    const overflow = `${style.overflow} ${style.overflowX} ${style.overflowY}`;
    return /(auto|scroll|hidden|clip)/.test(overflow);
};
const getPopupVisibleRect = (element) => {
    const rect = {
        left: popupViewportGap,
        top: popupViewportGap,
        right: window.innerWidth - popupViewportGap,
        bottom: window.innerHeight - popupViewportGap,
    };
    let current = element.parentElement;
    while (current && current !== document.body) {
        if (isClippingElement(current)) {
            const parentRect = current.getBoundingClientRect();
            rect.left = Math.max(rect.left, parentRect.left + popupViewportGap);
            rect.top = Math.max(rect.top, parentRect.top + popupViewportGap);
            rect.right = Math.min(rect.right, parentRect.right - popupViewportGap);
            rect.bottom = Math.min(rect.bottom, parentRect.bottom - popupViewportGap);
        }
        current = current.parentElement;
    }
    return rect;
};
const getPopupShift = (popupRect, visibleRect) => {
    let shiftX = 0;
    let shiftY = 0;
    if (visibleRect.right <= visibleRect.left || visibleRect.bottom <= visibleRect.top)
        return { shiftX, shiftY };
    if (popupRect.right > visibleRect.right) {
        const flipShift = -(popupRect.width + popupFlipGap);
        shiftX = popupRect.left + flipShift >= visibleRect.left
            ? flipShift
            : visibleRect.right - popupRect.right;
    }
    if (popupRect.left + shiftX < visibleRect.left)
        shiftX += visibleRect.left - (popupRect.left + shiftX);
    if (popupRect.bottom > visibleRect.bottom) {
        const flipShift = -(popupRect.height + popupFlipGap);
        shiftY = popupRect.top + flipShift >= visibleRect.top
            ? flipShift
            : visibleRect.bottom - popupRect.bottom;
    }
    if (popupRect.top + shiftY < visibleRect.top)
        shiftY += visibleRect.top - (popupRect.top + shiftY);
    return { shiftX, shiftY };
};
const formatPrice = (value, currency) => {
    const normalizedCurrency = currency || undefined;
    return `${formatMoney(value || 0, { currency: normalizedCurrency, localeAware: true })}${normalizedCurrency ? ` ${normalizedCurrency}` : ''}`;
};
export const getSeatPriceDetail = (service, serviceId, placeId) => {
    var _a;
    if (!service || !serviceId || !placeId)
        return undefined;
    return (_a = service.seatPriceDetails) === null || _a === void 0 ? void 0 : _a.find(d => d.serviceId === serviceId && d.placeId === placeId);
};
function SeatPricePopup({ seat, detail, priceConditions, currency, position }) {
    var _a;
    const contentRef = React.useRef(null);
    const title = (detail === null || detail === void 0 ? void 0 : detail.placeName) || seat.name || seat.id;
    const displayCurrency = (detail === null || detail === void 0 ? void 0 : detail.currency) || currency;
    const adjustment = detail ? ((_a = detail.adjustment) !== null && _a !== void 0 ? _a : (detail.finalPrice - detail.basePrice)) : 0;
    const adjustmentLabel = adjustment < 0 ? 'Скидка за место' : 'Доплата за место';
    React.useLayoutEffect(() => {
        var _a;
        const popupElement = (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        if (!popupElement)
            return;
        popupElement.style.transform = '';
        popupElement.style.pointerEvents = 'none';
        const visibleRect = getPopupVisibleRect(popupElement);
        const { shiftX, shiftY } = getPopupShift(popupElement.getBoundingClientRect(), visibleRect);
        popupElement.style.transform = shiftX || shiftY
            ? `translate(${shiftX}px, ${shiftY}px)`
            : '';
    }, [detail, priceConditions, position.x, position.y, seat.id]);
    return (React.createElement("div", { ref: contentRef, style: { minWidth: 230, padding: '2px 0' } },
        React.createElement(Typography, { variant: "subtitle2", style: { fontWeight: 600, marginBottom: 6 } },
            "\u041C\u0435\u0441\u0442\u043E ",
            title),
        detail ? (React.createElement("div", { style: priceRowStyle },
            React.createElement(Typography, { variant: "body2" }, adjustmentLabel),
            React.createElement(Typography, { variant: "body2", style: priceValueStyle }, formatPrice(Math.abs(adjustment), displayCurrency)))) : (priceConditions === null || priceConditions === void 0 ? void 0 : priceConditions.length) ? (priceConditions.map((condition, index) => (React.createElement("div", { key: `${condition.type}-${index}`, style: priceRowStyle },
            React.createElement(Typography, { variant: "body2" }, condition.type === 'discount' ? 'Скидка за место' : 'Доплата за место'),
            React.createElement(Typography, { variant: "body2", style: priceValueStyle }, condition.mode === 'percent' ? `${formatMoney(Math.abs(condition.value || 0), { precision: 2, localeAware: true })}%` : formatPrice(Math.abs(condition.value || 0), condition.currency || displayCurrency)))))) : null));
}
export const renderSeatPricePopup = (service, serviceId, currency) => (props) => {
    var _a;
    return (React.createElement(SeatPricePopup, Object.assign({}, props, { detail: getSeatPriceDetail(service, serviceId, (_a = props.seat) === null || _a === void 0 ? void 0 : _a.id), currency: currency })));
};
